import React from "react";
import { Row, Col } from "react-bootstrap";

const standardPanel = (contentVariable) => {
  return (
    <Row>
      <Col xs={0} md={1}>
      </Col>
      <Col className="content-background">{contentVariable}</Col>
      <Col xs={0} md={1}>
      </Col>
    </Row>
  );
};

const News = () => {
  const componentContent = (
    <div>
      <h2>Latest News and Updates</h2>
      
      <div className="news-item">
        <h3>April 2024: Distributed SAC Agent Now Supported</h3>
        <p className="news-date">April 18, 2024</p>
        <p>
          Vibe now supports distributed training mode with RLlib Soft Actor-Critic (SAC) agents,
          dramatically expanding our platform's capabilities for large-scale reinforcement
          learning applications. This addition enables researchers and engineers to:
        </p>
        <ul>
          <li>Scale SAC training across worker nodes</li>
          <li>Achieve significant speedups for complex environments</li>
          <li>Maintain stable learning performance at scale</li>
          <li>Leverage automatic workload distribution and synchronization</li>
        </ul>
        <p>
          This feature joins our existing support for StableBaselines3 PPO and RLlib DQN,
          making Vibe a comprehensive platform for distributed RL training.
        </p>
      </div>
    </div>
  );
  return standardPanel(componentContent);
};

export default News;